// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2-GF2","info":"UpdateTermsInfo_info__3E6gr"};